import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@core/environments/environment';
import { firstValueFrom, Observable } from 'rxjs';
import { LoadingService } from './loading.service';
import { AccountRMListResponse, AccountRMMetaDataResponse, GetAllRMsResponse, RMMetaDataResponse } from '@core/models/admin/roles-and-permissions/get-all-rm.model';
import { finalize, tap } from 'rxjs/operators';
import { Pagination } from '@core/models/pagination.model';

@Injectable({
  providedIn: 'root',
})
export class RelationshipManagerService {
  http = inject(HttpClient);
  private loadingService = inject(LoadingService);

  BASE_URL = environment.ADMIN_BASE_URL + '/v1/role';
  ACCOUNT_URL = environment.ADMIN_BASE_URL + '/v1/account';

  getAllRMs(): Observable<GetAllRMsResponse> {
    const uniqueStateUrl = 'get-all-relationship-managers';
    this.loadingService.setLoading(uniqueStateUrl, true);

    return this.http
      .get<GetAllRMsResponse>(`${this.BASE_URL}/get-relationship-manager`)
      .pipe(
        tap((res) => {
          console.log(res);
        }),
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  assignRM(payload: { admin_id: string; account_id: string }) {
    const uniqueStateUrl = 'assign-relationship-manager';
    this.loadingService.setLoading(uniqueStateUrl, true);

    return this.http
      .post(`${this.BASE_URL}/assign-relationship-manager`, payload)
      .pipe(
        tap((res) => {
          console.log(res);
        }),
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  getAllAccounts(
    data?: Pagination,
    search_text?: string
  ): Observable<AccountRMListResponse> {
    const uniqueStateUrl = 'get-all-account-with-rm-info';
    this.loadingService.setLoading(uniqueStateUrl, true);
    let url = `${this.ACCOUNT_URL}/get-all-account-with-rm-info`;
    let options: { params?: HttpParams } = {};

    if (search_text) {
      url = `${this.ACCOUNT_URL}/get-all-account-with-rm-info?${search_text}`;
    } else if (data?.size !== undefined && data?.skip !== undefined) {
      options.params = new HttpParams()
        .set('take', data.size)
        .set('skip', data.skip);
    }

    return this.http
      .get<AccountRMListResponse>(url, options)
      .pipe(
        finalize(() => this.loadingService.setLoading(uniqueStateUrl, false))
      );
  }

  getAccountRMListMetaData(): Observable<AccountRMMetaDataResponse> {
    return this.http.get<AccountRMMetaDataResponse>(
      `${this.ACCOUNT_URL}/get-relationship-manager-metadata`
    );
  }

  getRMMetaData(RMId: string): Observable<RMMetaDataResponse> {
    return this.http.get<RMMetaDataResponse>(
      `${this.ACCOUNT_URL}/get-metadata-by-relationship-manager?relationship_manager_id=${RMId}`
    );
  }

  transferRelationshipManager(payload: TransferRMPayload): Observable<any> {
    const uniqueStateUrl = 'reassign-relationship-manager';
    this.loadingService.setLoading(uniqueStateUrl, true);

    return this.http
      .post(`${this.ACCOUNT_URL}/reassign-relationship-manager`, payload)
      .pipe(finalize(() => this.loadingService.setLoading(uniqueStateUrl, false)));
  }
}

export interface TransferRMPayload {
  from_relationship_manager_id: string;
  to_relationship_manager_id: string;
  transfer_type: 'all' | 'category' | 'selected';
  account_type?: string;
  account_ids?: string[];
}
